<template>
    <div>
        <template v-if="data === true">
          <div class="corporate-cards-main">
            <iframe :src="iFrameUrl" frameborder="0" width="100%" title="E Money Statements"></iframe>
          </div>
        </template>
        <template v-if="data === null"><preLoader></preLoader></template>
        <template v-if="data === false"><notAllowed></notAllowed></template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
              corporate_card : null,
              iFrameUrl : null
            };
        },
        methods: {
          getIFrameUrl(){
            this.$Progress.start();
            axios.get('/api/getCorpCardIframeURL')
                .then(res => {
                  if(res.status == 200){
                    this.iFrameUrl = res.data;
                    this.data = true;
                  }else{
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                  }
                })
                .catch(err => {
                  this.$Progress.fail();
                  this.showAlertBox('error','system error');
                  console.log(err);
                });
            }
        },
        mounted() {
          var gThat = this;
            this.$Progress.start();

            this.can('corporate_card').then(result=>{
                 this.corporate_card = result.corporate_card;
                // this.corporate_card = true;
            }).then(result=>{
                if(this.corporate_card === true){
                  this.getIFrameUrl();
                }else{
                  this.data = false;
                }
            })
          }
    }
</script>
